<template>
  <div :class="isSticky ? 'theme-main-menu sticky-menu theme-menu-four bg-none fixed'
  : 'theme-main-menu sticky-menu theme-menu-four bg-none'">
    <div class="d-flex align-items-center justify-content-between">
      <div class="logo">
        <router-link to="/">
          <img src="../../../assets/images/logo/logo-black.svg" alt="" />
        </router-link>
      </div>
      <nav id="mega-menu-holder" class="navbar navbar-expand-lg">
        <div class="nav-container">
          <button class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar"
            :class="menuActive ? 'navbar-toggler open' : 'navbar-toggler'" @click="menuActive = !menuActive">
            <span></span>
          </button>
          <div class="navbar-collapse collapse" id="collapsibleNavbar">
            <div class="d-lg-flex align-items-center">
              <!-- nav menu start -->
                <NavBasic/>
                <!-- nav menu end -->
              <ul class="right-button-group d-flex align-items-center justify-content-center">
                <li>
                  <a href="tel:01132456133" class="contact-button contact-button--blue">
                    Call us
                  </a>
                </li>
                <li>
                  <a href="mailto:sales@marshallprint.co.uk?subject=Inquiry&body=---%0AContext: Header link"
                     class="contact-button">
                    Email us
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import NavBasic from './NavBasic.vue';

export default {
  name: "HeaderTwo",
  components:{
    NavBasic
  },
  data() {
    return {
      isSticky: false,
      menuActive: false,
    }
  },
  methods: {
    handleSticky() {
      if (window.scrollY > 80) {
        this.isSticky = true;
      }
      else {
        this.isSticky = false;
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleSticky)
  },
};
</script>

<style lang="scss" scoped>
.theme-main-menu.theme-menu-four {
  background-color: #fff;
  padding: 1.5rem 4rem;
  @media (max-width: 991px) {
    padding: 1rem;
  }

  .navbar-toggler {
    background-color: var(--darkblue);
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
  }

  .navbar-collapse {
    background-color: #fff;
  }

  .logo {
    display: block;
    margin: 0;
    //padding: 1rem 0;
    transition: transform 0.5s ease-in-out;
    @media (max-width: 991px) {
      padding: 0;
    }

    img {
      height: auto;
      max-width: 10rem;
      transition: transform 0.5s ease-in-out;
      width: 10rem;
      @media (max-width: 991px) {
        max-width: 7rem;
        width: 7rem;
      }
    }
  }

  .contact-button {
    background-color: var(--pink);
    border-radius: 0.25rem;
    box-shadow: 0 13px 35px -12px rgba(35, 35, 35, 0.3);
    color: #fff;
    margin: 0 0 0 1rem;
    padding: 0.25rem 2rem;
    &--blue {
      background-color: var(--lightblue);
    }
    @media (max-width: 991px) {
      padding: 0.25rem 1rem;
    }
  }
}

.theme-main-menu.sticky-menu.fixed.theme-menu-four {
  box-shadow: 0 13px 35px -12px rgba(35, 35, 35, 0.3);
  background-color: #fff;
  padding: 0.5rem 1rem;
  transition: all 0.3s ease-in-out;
  @media (min-width: 991px) {
    padding: 0.5rem 4rem;
    .logo {
        transform: scale(0.75);
        transform-origin: left center;
        transition: transform 0.5s ease-in-out;
    }
  }
}
.theme-menu-four .navbar-nav .nav-item.active .nav-link {
    color: var(--darkblue);
}

</style>
